module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day03_02_stay-cdfbbfee289b0454e42e3ecffa440709.jpg";